import SiteRoute from 'routes/';
// import 'react-quill/dist/quill.snow.css';

function App() {
  return <>{SiteRoute}</>;
}

export default App;
